"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultIsSelected = void 0;
const defaultIsSelected = ({ rowIndex, columnIndex, data, rowKey, columnKey }) => {
    if (Array.isArray(data)) {
        const row = data[rowIndex];
        if (Array.isArray(row)) {
            return !!row[columnIndex];
        }
    }
    if (rowKey && typeof data === 'object' && (data === null || data === void 0 ? void 0 : data.hasOwnProperty(rowKey))) {
        const row = data[rowKey || ''];
        if (Array.isArray(row)) {
            return !!row[columnIndex];
        }
        if (columnKey && typeof row === 'object' && (row === null || row === void 0 ? void 0 : row.hasOwnProperty(columnKey))) {
            return !!row[columnKey];
        }
    }
    return false;
};
exports.defaultIsSelected = defaultIsSelected;
//# sourceMappingURL=defaultIsSelected.js.map